import { render } from "./DiscourseTree.vue?vue&type=template&id=709f183f&scoped=true"
import script from "./DiscourseTree.vue?vue&type=script&lang=js"
export * from "./DiscourseTree.vue?vue&type=script&lang=js"

import "./DiscourseTree.vue?vue&type=style&index=0&id=709f183f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709f183f"]])

export default __exports__